import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { OnboardingTaskProgress } from './onboarding-task-progress.model'

@Injectable({ providedIn: 'root' })
export class OnboardingTaskProgressStore extends EntitySignalStore<OnboardingTaskProgress> {
  constructor() {
    super({
      name: 'onboardingTaskProgress',
      entityConstructor: progress => new OnboardingTaskProgress(progress)
    })
  }
}
